import { useState, createContext, useContext, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";

import { AuthContext } from "@/contexts/auth";
import { downloadUrl } from "@/utils/download";
import { debugLog } from "@/utils/debugLog";

export const TaskContext = createContext();

export const TaskProvider = ({ children }) => {
  const { token } = useContext(AuthContext);
  const [taskrequestId, setTaskrequestId] = useState("");
  const [ownerContractFilterList, setOwnerContractFilterList] = useState({
    venueId: [],
    taskreqstatusId: [],
    pp: 50,
    page: 1,
    frequency: "",
    cat_search: 0,
    crew_search: 0,
    q: "",
    equal: 0
  });
  const [crewContractFilterList, setCrewContractFilterList] = useState({
    venueId: [],
    taskcategoryId: [],
    pp: 50,
    page: 1
  });
  const [ownerFilterList, setOwnerFilterList] = useState({
    venueId: [],
    cat_search: 0,
    crew_search: 0,
    q: "",
    equal: 0,
    scheduledMonth: [],
    statusId: [],
    problem: false,
    page: 1,
    tab: "task",
    pastDue: false,
    sortDesc: false,
    frequency: "",
    bookmark: false,
    taskrptsHaveProblems: false
  });
  const [crewFilterList, setCrewFilterList] = useState({
    venueId: [],
    taskcategoryId: [],
    scheduledMonth: [],
    status: "",
    suggestionStatus: 0,
    page: 1,
    tab: "task"
  });
  const [downloadData, setDownloadData] = useState({
    id: "",
    status: "",
    progress: "",
    file: {}
  });
  const [selectedTaskId, setSelectedTaskId] = useState([]);
  const [allVenues, setAllVenues] = useState([]);
  const [scrollY, setScrollY] = useState({
    task: 0,
    contract: 0,
    venue: 0,
    type: 0
  });

  useEffect(() => {
    if (!downloadData.id) return;
    const downloadUrlCheck = async () => {
      await axios
        .get(
          `${process.env.APP_API_PATH}/owner/download-request/${downloadData.id}`,
          token
        )
        .then((res) => {
          if (downloadData.id) {
            debugLog(res.data);
            downloadData.status = res.data.status;
            downloadData.progress = res.data.progress;
            downloadData.file = res.data.file;
            setDownloadData({ ...downloadData });
          }
        })
        .catch((e) => {
          debugLog(e);
        });
    };
    if (downloadData.status === "done") {
      downloadUrl(
        `${process.env.APP_PHOTO_URL}/${downloadData.file.path}`,
        `${dayjs().format("YYYYMMDD")}_report.zip`
      );
      setDownloadData({
        ...{ id: "", status: "", progress: "", file: {} }
      });
      setSelectedTaskId([]);
    } else {
      setTimeout(() => downloadUrlCheck(), 1000);
    }
  }, [downloadData]);

  return (
    <TaskContext.Provider
      value={{
        taskrequestId,
        setTaskrequestId,
        ownerContractFilterList,
        setOwnerContractFilterList,
        crewContractFilterList,
        setCrewContractFilterList,
        ownerFilterList,
        setOwnerFilterList,
        crewFilterList,
        setCrewFilterList,
        downloadData,
        setDownloadData,
        selectedTaskId,
        setSelectedTaskId,
        scrollY,
        setScrollY,
        allVenues,
        setAllVenues
      }}
    >
      {children}
    </TaskContext.Provider>
  );
};
